import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/PersonasSlice';

const selectDomain = (state: RootState) => state?.personas || initialState;

export const selectPersonas = createSelector(
  [selectDomain],
  (state) => state.personas,
);

export const selectPersonaCount = createSelector(
  [selectDomain],
  (state) => state.personaCount,
);

export const selectPersonasLoading = createSelector(
  [selectDomain],
  (state) => state.personasLoading,
);

export const selectPersonasLoaded = createSelector(
  [selectDomain],
  (state) => state.personasLoaded,
);

export const selectPersonasPage = createSelector(
  [selectDomain],
  (state) => state.personasPage,
);

export const selectPersonasEnded = createSelector(
  [selectDomain],
  (state) => state.personasEnded,
);

export const selectPersonasSearchText = createSelector(
  [selectDomain],
  (state) => state.searchText,
);

export const selectDeleteLoading = createSelector(
  [selectDomain],
  (state) => state.deleteLoading,
);

export const selectNameCheckLoading = createSelector(
  [selectDomain],
  (state) => state.nameCheckLoading,
);

export const selectNameCheckError = createSelector(
  [selectDomain],
  (state) => state.nameCheckError,
);

export const selectDraftPersonaName = createSelector(
  [selectDomain],
  (state) => state.draftPersonaName,
);

export const selectPersonaNameChecked = createSelector(
  [selectDomain],
  (state) => state.personaNameChecked,
);

export const selectDraftPersonaId = createSelector(
  [selectDomain],
  (state) => state.draftPersonaId,
);

export const selectGenerateLoading = createSelector(
  [selectDomain],
  (state) => state.generateLoading,
);

export const selectGeneratedTitles = createSelector(
  [selectDomain],
  (state) => state.generatedTitles,
);

export const selectPersonaGenerated = createSelector(
  [selectDomain],
  (state) => state.personaGenerated,
);

export const selectDeletingTitleIds = createSelector(
  [selectDomain],
  (state) => state.deletingTitleIds,
);

export const selectTogglingTitleIds = createSelector(
  [selectDomain],
  (state) => state.togglingTitleIds,
);

export const selectDetailsLoading = createSelector(
  [selectDomain],
  (state) => state.detailsLoading,
);

export const selectPersonaDetails = createSelector(
  [selectDomain],
  (state) => state.personaDetails,
);

export const selectResultCountLoading = createSelector(
  [selectDomain],
  (state) => state.resultCountLoading,
);

export const selectResultCountLoaded = createSelector(
  [selectDomain],
  (state) => state.resultCountLoaded,
);

export const selectResultCount = createSelector(
  [selectDomain],
  (state) => state.resultCount,
);

export const selectListStatus = createSelector(
  [selectDomain],
  (state) => state.listStatus,
);

export const selectListDescription = createSelector(
  [selectDomain],
  (state) => state.listDescription,
);

export const selectConfirmError = createSelector(
  [selectDomain],
  (state) => state.confirmError,
);

export const selectPersonaConfirmed = createSelector(
  [selectDomain],
  (state) => state.personaConfirmed,
);

export const selectResultsTotal = createSelector(
  [selectDomain],
  (state) => state.resultsTotal,
);

export const selectResultsProspects = createSelector(
  [selectDomain],
  (state) => state.resultsProspects,
);

export const selectResultsPage = createSelector(
  [selectDomain],
  (state) => state.resultsPage,
);

export const selectResultsLoading = createSelector(
  [selectDomain],
  (state) => state.resultsLoading,
);

export const selectResultsEnded = createSelector(
  [selectDomain],
  (state) => state.resultsEnded,
);
